"use client";

import { Switch as SwitchPrimitive } from "radix-ui";
import type * as React from "react";

function Switch({
	className,
	...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
	return (
		<SwitchPrimitive.Root
			data-slot="switch"
			className={className ? `peer ${className}` : "peer"}
			{...props}
		>
			<SwitchPrimitive.Thumb data-slot="switch-thumb" />
		</SwitchPrimitive.Root>
	);
}

export { Switch };
